// Minimal ISO-8601 duration support for touchpoint wait_time. Handles the
// day/hour/minute subset the journey builder uses (e.g. P2D, PT24H, PT30M).
const RE = /^P(?:(\d+(?:\.\d+)?)D)?(?:T(?:(\d+(?:\.\d+)?)H)?(?:(\d+(?:\.\d+)?)M)?)?$/;

export function isoToDays(iso) {
  if (!iso) return 0;
  const m = RE.exec(iso);
  if (!m) return 0;
  const days = parseFloat(m[1] || 0);
  const hours = parseFloat(m[2] || 0);
  const mins = parseFloat(m[3] || 0);
  return days + hours / 24 + mins / (24 * 60);
}

export function isoToLabel(iso) {
  const d = isoToDays(iso);
  if (d === 0) return '0 delay';
  if (Number.isInteger(d)) return `${d} day${d === 1 ? '' : 's'}`;
  const hours = Math.round(d * 24);
  return `${hours} hour${hours === 1 ? '' : 's'}`;
}
